import React from 'react';

const PartE = ({ data }) => {
  const courses = data?.courses || Array(10).fill({ course_name: '', hours: 0, completed: false });

  const getTotalHours = () => {
    return courses.reduce((sum, course) => sum + (course.hours || 0), 0);
  };

  const rowLabels = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      {/* Top-right orange corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #FF8C42 transparent transparent'
      }} />

      {/* Header: PART E */}
      <div style={{
        color: '#FF8C42',
        fontSize: '22px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '8px',
        letterSpacing: '2px'
      }}>
        PART E
      </div>

      {/* Title: Learning through Online Courses */}
      <div style={{
        color: '#2C5F7E',
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'left',
        marginBottom: '20px'
      }}>
        Learning through Online Courses
      </div>

      {/* Table */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #888',
        marginBottom: '30px'
      }}>
        {/* Table Header - "Online Course" spanning row */}
        <thead>
          <tr style={{ backgroundColor: '#F4CD8A' }}>
            <th colSpan={4} style={{
              padding: '10px',
              textAlign: 'left',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              Online Course
            </th>
          </tr>
          {/* Column Headers */}
          <tr style={{ backgroundColor: '#F4E4B8' }}>
            <th style={{
              width: '50px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'normal',
              color: '#333',
              border: '1px solid #888',
              backgroundColor: '#FFF9E6'
            }}></th>
            <th style={{
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Course
            </th>
            <th style={{
              width: '140px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Number of Hours
            </th>
            <th style={{
              width: '120px',
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#333',
              border: '1px solid #888'
            }}>
              Completed (✓)
            </th>
          </tr>
        </thead>

        {/* Table Body - 10 rows */}
        <tbody>
          {courses.slice(0, 10).map((course, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFEF8' : '#FFF9E6' }}>
              <td style={{
                padding: '8px',
                textAlign: 'center',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                fontWeight: 'bold'
              }}>
                {rowLabels[index]})
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888'
              }}>
                {course.course_name || '-'}
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                {course.hours || 0}
              </td>
              <td style={{
                padding: '8px',
                fontSize: '12px',
                color: '#333',
                border: '1px solid #888',
                textAlign: 'center'
              }}>
                {course.completed ? '✓' : ''}
              </td>
            </tr>
          ))}
        </tbody>

        {/* Table Footer - Total Hours */}
        <tfoot>
          <tr style={{ backgroundColor: '#F4CD8A' }}>
            <td style={{
              padding: '10px',
              border: '1px solid #888'
            }}></td>
            <td style={{
              padding: '10px',
              textAlign: 'right',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              TOTAL HOURS
            </td>
            <td style={{
              padding: '10px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#333',
              border: '1px solid #888'
            }}>
              {getTotalHours()}
            </td>
            <td style={{
              padding: '10px',
              border: '1px solid #888'
            }}></td>
          </tr>
        </tfoot>
      </table>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        38
      </div>

      {/* Bottom-left orange corner */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #FF8C42'
      }} />

      {/* Bottom-right decorative corner */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '50px 50px 0 0',
        borderColor: 'transparent #FFB347 transparent transparent',
        opacity: 0.5
      }} />
    </div>
  );
};

export default PartE;
